// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".character-counter[data-v-01a20fa9] {\n  color: #c1c1c1;\n  float: right;\n}\n.limit-reached[data-v-01a20fa9] {\n  color: #ff7901;\n}\n", ""]);
// Exports
module.exports = exports;
